import React from 'react';
import { Box } from '@mui/material';
import ByzMuiSaveButton from 'src/components/core-components/mui/buttons/ByzMuiSaveButton';
import { OtherPrivilegeGuard } from 'src/utils/authorization/OtherPrivilegeGuard';
import { useTranslate } from 'src/locales/use-locales';

interface SaveButtonWrapperProps {
  onSave: () => void;
  isSaving?: boolean;
  extraAccess?: boolean;
}

export const SaveButtonWrapper: React.FC<SaveButtonWrapperProps> = ({
  onSave,
  isSaving,
  extraAccess,
}) => {
  const { t } = useTranslate();

  return (
    <Box mb={3}>
      <OtherPrivilegeGuard
        extraAccess={!!extraAccess}
        fallback={
          <ByzMuiSaveButton
            disabled
            tooltip={!extraAccess ? t('no-permission-for-this-action') : undefined}
          />
        }
      >
        <ByzMuiSaveButton onClick={onSave} loading={isSaving} />
      </OtherPrivilegeGuard>
    </Box>
  );
};

